var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58508 1H3.58508C3.05465 1 2.54594 1.21071 2.17087 1.58579C1.7958 1.96086 1.58508 2.46957 1.58508 3V7M7.58508 1H17.5851C18.1155 1 18.6242 1.21071 18.9993 1.58579C19.3744 1.96086 19.5851 2.46957 19.5851 3V7M7.58508 1V19M1.58508 7V17C1.58508 17.5304 1.7958 18.0391 2.17087 18.4142C2.54594 18.7893 3.05465 19 3.58508 19H7.58508M1.58508 7H19.5851M19.5851 7V17C19.5851 17.5304 19.3744 18.0391 18.9993 18.4142C18.6242 18.7893 18.1155 19 17.5851 19H7.58508",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeProfile);
export default __webpack_public_path__ + "static/media/TimeProfile.083171bd9d7fc03dbde9ef96e5cbea69.svg";
export { ForwardRef as ReactComponent };